import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Spin } from 'antd-v5';
import { getInquiriesByVendorItem } from '../../../../../api/vendors';
import { formatInquiryDate } from '../../../../Routes/Rolex/utils';
import './styles.scss';

const RolexInquiriesPopover = ({ vendorItemId, onAddInquiry, onClose }) => {
  const history = useHistory();
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!vendorItemId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    getInquiriesByVendorItem(vendorItemId)
      .then(response => {
        const items = (response?.data || response || []).map(item => ({
          ...item,
          date: formatInquiryDate(item.inquiryDate || item.date),
          duration: typeof item.durationMonths === 'number' ? `${item.durationMonths} months` : item.duration || '',
        }));
        setInquiries(items);
      })
      .catch(() => setInquiries([]))
      .finally(() => setLoading(false));
  }, [vendorItemId]);

  const handleInquiryClick = inquiry => {
    onClose();
    history.push(`/Clients?client=${inquiry.clientId}&clientTab=rolex`);
  };

  const handleAddClick = () => {
    onClose();
    onAddInquiry();
  };

  return (
    <div className="rolex-inquiries-popover">
      <div className="rolex-inquiries-popover__header">
        <span className="rolex-inquiries-popover__title">Rolex Inquiries</span>
        <PlusCircleOutlined className="rolex-inquiries-popover__add-btn" onClick={handleAddClick} />
      </div>
      <div className="rolex-inquiries-popover__list">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 16 }}>
            <Spin size="small" />
          </div>
        ) : inquiries.length === 0 ? (
          <div className="rolex-inquiries-popover__empty">No open inquiries</div>
        ) : (
          inquiries.map(inquiry => (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div key={inquiry.id} className="rolex-inquiries-popover__item" onClick={() => handleInquiryClick(inquiry)}>
              <span className="rolex-inquiries-popover__client-name">{inquiry.clientName}</span>
              <span className="rolex-inquiries-popover__date">
                {inquiry.date} ({inquiry.duration})
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RolexInquiriesPopover;
